import React, { useMemo } from 'react';
import { IFabricationOrder } from '../../../../../store/ducks/fabrication-orders/types';
import { ObservationContainer } from './styles';
import { TitleContainer, TableContainer } from '../styles';
import { Table } from '@gerdau/hefesto-mais-web';
import { Title } from '@gerdau/hefesto';

interface IDetailingProjectContentProps {
  fabricationOrder: IFabricationOrder;
}

interface IDetailingProjectTableDataSource {
  key: number;
  projectName: string;
  revision: string;
  pavement: string;
  amount: number | undefined;
  completeDrawing: boolean;
  observation: string;
}

const DetailingProjectContent: React.FC<IDetailingProjectContentProps> = ({
  fabricationOrder
}) => {
  const getProjectName = (projectId: number | undefined): string => {
    const project = fabricationOrder.projects.find(
      (proj) => proj.id === projectId
    );
    return project ? project.fileName : '-';
  };

  const detailingDataSourceProject: IDetailingProjectTableDataSource[] =
    useMemo(() => {
      return fabricationOrder.itens.map(
        (
          {
            projectId,
            revision,
            pavement,
            amount,
            completeDrawing,
            observation
          },
          idx
        ) => ({
          key: idx,
          projectName: getProjectName(projectId),
          revision,
          pavement,
          amount,
          completeDrawing,
          observation
        })
      );
    }, [fabricationOrder.itens]);

  const getColumns = () => {
    const columns = [
      {
        title: 'Arquivo do projeto',
        dataIndex: 'projectName',
        render: (text: string) => <>{text}</>
      },
      {
        title: 'Revisão',
        dataIndex: 'revision',
        render: (text: string) => <>{text}</>
      },
      {
        title: 'Pavimento',
        dataIndex: 'pavement',
        render: (text: string) => <>{text ?? '-'}</>
      },
      {
        title: 'Nº de repetições',
        dataIndex: 'amount',
        render: (text: number) => <>{text}</>
      },
      {
        title: 'Desenho completo',
        dataIndex: 'completeDrawing',
        render: (text: boolean) => <>{text ? 'Sim' : 'Não'}</>
      },
      {
        title: 'Observações',
        dataIndex: 'observation',
        render: (text: string) => <>{text}</>
      }
    ];

    return columns;
  };

  return (
    <>
      <TitleContainer>
        <Title level={2}>Detalhamento do projeto</Title>
      </TitleContainer>
      <TableContainer>
        <Table
          columns={getColumns()}
          dataSource={detailingDataSourceProject}
        ></Table>
      </TableContainer>
      <ObservationContainer>
        <span className="title">Observações</span>
        <span className="description">
          {fabricationOrder.observation || '-'}
        </span>
      </ObservationContainer>
    </>
  );
};

export default DetailingProjectContent;
